import { render, staticRenderFns } from "./WaitPurchaseDetail.vue?vue&type=template&id=1417c8d4&"
import script from "./WaitPurchaseDetail.vue?vue&type=script&lang=js&"
export * from "./WaitPurchaseDetail.vue?vue&type=script&lang=js&"
import style0 from "./WaitPurchaseDetail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports